import { API, graphqlOperation } from "aws-amplify";
import React from "react";
import Loading from "_shared/components/Loading/Loading";
import SectorPerformanceData from "./SectorPerformanceData";
// const defaultTickers = {
//   xlc: 0,
//   xly: 0,
//   xlp: 0,
//   xle: 0,
//   xlf: 0,
//   xlv: 0,
//   xli: 0,
//   xlre: 0,
//   xlk: 0,
//   xlu: 0,
//   xlb: 0,
//   xhb: 0,
//   xme: 0,
//   smh: 0,
//   iyt: 0,
// };
// const defaultData = {
//   closingPrice: defaultTickers,
//   oneDayChange: defaultTickers,
//   fiveDayChange: defaultTickers,
//   oneMonthChange: defaultTickers,
//   threeMonthChange: defaultTickers,
//   oneYearChange: defaultTickers,
// };
const graphQLAttributes = `
  current_trr_1d
  current_trr_5d
  current_trr_1mo
  current_trr_3mo
  current_trr_ytd
  red_px_last
  red_current_trr_1d
  red_current_trr_5d
  red_current_trr_1mo
  red_current_trr_3mo
  red_current_trr_ytd
  algo_eod_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH
  algo_eod_CALC_POSITION_LONGBOW_SIGNAL
  algo_eod_PX_LAST
`;

export default function SectorPerformance(props) {
  // const [data, setData] = React.useState(defaultData);
  const [refresh, setRefresh] = React.useState(false);
  const [testData, setTestData] = React.useState(null);
  const [sortData, setSortData] = React.useState("not-sorted");

  React.useEffect(() => {
    refreshData();
  }, []);

  // React.useEffect(() => {
  //   if (props.reload) {
  //     setData(defaultData);
  //     refreshData();
  //   }
  // }, [props.reload]);

  const refreshData = async () => {
    const data = (
      await API.graphql(
        graphqlOperation(`{
        SPY: data3_by_pk(ticker: "SPY US Equity") {${graphQLAttributes}}
        XLY: data3_by_pk(ticker: "XLY US Equity") {${graphQLAttributes}}
        XLF: data3_by_pk(ticker: "XLF US Equity") {${graphQLAttributes}}
        XLV: data3_by_pk(ticker: "XLV US Equity") {${graphQLAttributes}}
        XLK: data3_by_pk(ticker: "XLK US Equity") {${graphQLAttributes}}
        XLP: data3_by_pk(ticker: "XLP US Equity") {${graphQLAttributes}}
        XLI: data3_by_pk(ticker: "XLI US Equity") {${graphQLAttributes}}
        XLB: data3_by_pk(ticker: "XLB US Equity") {${graphQLAttributes}}
        XLE: data3_by_pk(ticker: "XLE US Equity") {${graphQLAttributes}}
        XLU: data3_by_pk(ticker: "XLU US Equity") {${graphQLAttributes}}
        XLRE: data3_by_pk(ticker: "XLRE US Equity") {${graphQLAttributes}}
        XLC: data3_by_pk(ticker: "XLC US Equity") {${graphQLAttributes}}
        XHB: data3_by_pk(ticker: "XHB US Equity") {${graphQLAttributes}}
        XME: data3_by_pk(ticker: "XME US Equity") {${graphQLAttributes}}
        SMH: data3_by_pk(ticker: "SMH US Equity") {${graphQLAttributes}}
        IYT: data3_by_pk(ticker: "IYT US Equity") {${graphQLAttributes}}
      } `),
      )
    ).data;
    setTestData(data);
  };
  if (!testData) return <Loading variant="inner" />;

  return (
    <section className="section sector-performance">
      <div className="section-title">Sector/Industry Performance</div>

      <div className="sub-header-sector">
        <div className="sub-header-index">
          <div className="transparent">.</div>
          <div style={{ paddingLeft: 20 }}>Sector ETF</div>
        </div>
        <div className="sub-header-index">
          <div style={{ textAlign: "center" }}>ETF</div>
          <div style={{ textAlign: "center" }}>Ticker</div>
        </div>
        <div
          className="sub-header-text"
          style={{ marginTop: -17, display: "flex", justifyContent: "center" }}
        >
          <div>
            <div>Core</div>
            <div>Signal</div>
            <div>Strength</div>
          </div>
          <div style={{ position: "relative", left: -10 }}>
            <div
              style={{
                cursor: "pointer",
                color: sortData === "low-high-signal" ? "#75ce41" : null,
              }}
              onClick={() => {
                if (sortData !== "low-high-signal")
                  setSortData("low-high-signal");
                else setSortData("not-sorted");
              }}
            >
              ▲
            </div>
            <div
              style={{
                cursor: "pointer",
                color: sortData === "high-low-signal" ? "#75ce41" : null,
              }}
              onClick={() => {
                if (sortData !== "high-low-signal")
                  setSortData("high-low-signal");
                else setSortData("not-sorted");
              }}
            >
              ▼
            </div>
          </div>
        </div>
        <div
          className="sub-header-text"
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div>
            <div className="justify-center">Closing</div>
            <div className="justify-center">Price</div>
          </div>
        </div>
        <div
          className="sub-header-text"
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div>
            <div className="justify-center">1D</div>
            <div className="sub-header-line"></div>
            <div className="justify-center">% Chg</div>
          </div>
          <div style={{ marginLeft: 2 }}>
            <div
              style={{
                cursor: "pointer",
                color: sortData === "low-high-1d" ? "#75ce41" : null,
              }}
              onClick={() => {
                if (sortData !== "low-high-1d") setSortData("low-high-1d");
                else setSortData("not-sorted");
              }}
            >
              ▲
            </div>
            <div
              style={{
                cursor: "pointer",
                color: sortData === "high-low-1d" ? "#75ce41" : null,
              }}
              onClick={() => {
                if (sortData !== "high-low-1d") setSortData("high-low-1d");
                else setSortData("not-sorted");
              }}
            >
              ▼
            </div>
          </div>
        </div>
        <div
          className="sub-header-text"
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div>
            <div className="justify-center">1W</div>
            <div className="sub-header-line"></div>
            <div className="justify-center">% Chg</div>
          </div>

          <div style={{ marginLeft: 2 }}>
            <div
              style={{
                cursor: "pointer",
                color: sortData === "low-high-1w" ? "#75ce41" : null,
              }}
              onClick={() => {
                if (sortData !== "low-high-1w") setSortData("low-high-1w");
                else setSortData("not-sorted");
              }}
            >
              ▲
            </div>
            <div
              style={{
                cursor: "pointer",
                color: sortData === "high-low-1w" ? "#75ce41" : null,
              }}
              onClick={() => {
                if (sortData !== "high-low-1w") setSortData("high-low-1w");
                else setSortData("not-sorted");
              }}
            >
              ▼
            </div>
          </div>
        </div>
        <div
          className="sub-header-text"
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div>
            <div className="justify-center">1M</div>
            <div className="sub-header-line"></div>
            <div className="justify-center">% Chg</div>
          </div>

          <div style={{ marginLeft: 2 }}>
            <div
              style={{
                cursor: "pointer",
                color: sortData === "low-high-1m" ? "#75ce41" : null,
              }}
              onClick={() => {
                if (sortData !== "low-high-1m") setSortData("low-high-1m");
                else setSortData("not-sorted");
              }}
            >
              ▲
            </div>
            <div
              style={{
                cursor: "pointer",
                color: sortData === "high-low-1m" ? "#75ce41" : null,
              }}
              onClick={() => {
                if (sortData !== "high-low-1m") setSortData("high-low-1m");
                else setSortData("not-sorted");
              }}
            >
              ▼
            </div>
          </div>
        </div>
        <div
          className="sub-header-text"
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div>
            <div className="justify-center">3M</div>
            <div className="sub-header-line"></div>
            <div className="justify-center">% Chg</div>
          </div>

          <div style={{ marginLeft: 2 }}>
            <div
              style={{
                cursor: "pointer",
                color: sortData === "low-high-3m" ? "#75ce41" : null,
              }}
              onClick={() => {
                if (sortData !== "low-high-3m") setSortData("low-high-3m");
                else setSortData("not-sorted");
              }}
            >
              ▲
            </div>
            <div
              style={{
                cursor: "pointer",
                color: sortData === "high-low-3m" ? "#75ce41" : null,
              }}
              onClick={() => {
                if (sortData !== "high-low-3m") setSortData("high-low-3m");
                else setSortData("not-sorted");
              }}
            >
              ▼
            </div>
          </div>
        </div>
        <div
          className="sub-header-text"
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div>
            <div className="justify-center">YTD</div>
            <div className="sub-header-line"></div>
            <div className="justify-center">%</div>
          </div>

          <div style={{ marginLeft: 2 }}>
            <div
              style={{
                cursor: "pointer",
                color: sortData === "low-high-ytd" ? "#75ce41" : null,
              }}
              onClick={() => {
                if (sortData !== "low-high-ytd") setSortData("low-high-ytd");
                else setSortData("not-sorted");
              }}
            >
              ▲
            </div>
            <div
              style={{
                cursor: "pointer",
                color: sortData === "high-low-ytd" ? "#75ce41" : null,
              }}
              onClick={() => {
                if (sortData !== "high-low-ytd") setSortData("high-low-ytd");
                else setSortData("not-sorted");
              }}
            >
              ▼
            </div>
          </div>
        </div>
      </div>
      <div className="sector-performance-content">
        <SectorPerformanceData
          testData={testData}
          sortData={sortData}
          refresh={() => {
            setRefresh(!refresh);
          }}
        />
      </div>
    </section>
  );
}
